import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { dispatch } from "../../../store";
import { fetchCourses } from "../../../store/slices/courses";
import { useSelector } from "react-redux";

const CourseSelectionDropdown = ({ onChange, inputLabelStyle = {}, variant = 'standard' }) => {
  const learnerState = useSelector((state) => state.learner || {});
  const coursesState = useSelector((state) => state.courses || {});
  const [value, setValue] = useState(learnerState.details?.selectedCourseIdComparison || 'default');

  useEffect(() => {
    setValue(learnerState.details?.selectedCourseIdComparison || 'default');
  }, [learnerState]);

  useEffect(() => {
    const getCourses = async () => {
      await dispatch(fetchCourses());
    };
    getCourses();
  }, []);

  const handleChange = (event) => {
    const selectedCourse = event.target.value;
    onChange(selectedCourse);
    setValue(selectedCourse);
  };

  const isDisabled = learnerState?.details && 
    learnerState.details?.inviteCode &&
    learnerState.details?.selectedCourseIdComparison &&
    learnerState.details?.selectedCourseIdComparison !== 'default';

  // Filter out private courses when the select is not disabled
  const filteredCourses = isDisabled 
    ? coursesState.courses 
    : coursesState.courses.filter(course => !course.isPrivate);

  return (
    <>
      <FormControl fullWidth sx={{ textAlign: "left" }}>
        <InputLabel
          sx={inputLabelStyle}
          id="course-selection-label"
        >
          Course
        </InputLabel>
        <Select
          labelId="course-selection-label"
          id="demo-simple-select"
          label="Select Course"
          variant={variant}
          onChange={handleChange}
          value={value}
          disabled={isDisabled}
        >
          <MenuItem value={"default"}>I'm not sure which course I'm interested in.</MenuItem>
          {filteredCourses.map((course) => (
            <MenuItem key={course._id} value={course._id}>
              {course.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default CourseSelectionDropdown;
